import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sftp-auth-method"
export default class extends Controller {
  static targets = ["select", "password", "key"]

  connect() {
    const selectedValue = this.selectTarget.value;
    this.change({target: {value: selectedValue}});
  }

  change(event) {
    const selectedValue = event.target.value;
    const passwordField = this.passwordTarget;
    const keyField = this.keyTarget;

    if (selectedValue === "password") {
      passwordField.classList.remove("hidden");
      passwordField.required = true;
      keyField.classList.add("hidden");
      keyField.required = false;
    } else if (selectedValue === "key") {
      keyField.classList.remove("hidden");
      keyField.required = true;
      passwordField.classList.add("hidden");
      passwordField.required = false;
    }
  }
}
